import React from "react";
import CountUp from "react-countup";
import { Translation } from "../../Translation";
import { appConfig } from "../../config";
import SmoothScrolling from "../../Helpers/smootScrolling";
import FooterButtons from "./FooterButtons";
import { inject, observer } from "mobx-react";

@inject("AppStore")
@observer
class Footer extends React.Component {
  store = this.props.AppStore;

  render() {
    const { summary, lastPrice, location } = this.store;

    return (
      <div className="footer">
        {!this.store.page.completed && (
          <React.Fragment>
            <div className="price-summary">
              {appConfig.locale.showPrice && (
                <>
                  <div className="payment-options">
                    <span>
                      <Translation t="PRICE" lang={this.store.page.lang} />
                    </span>
                  </div>
                  <div className="price-display">
                    <CountUp
                      className="price-text"
                      separator="."
                      decimals={0}
                      decimal=","
                      prefix={location.symbol}
                      duration={1}
                      start={lastPrice}
                      end={summary.purchase_price}
                      preserveValue={true}
                      redraw={true}
                      key={summary.purchase_price} // Force re-render when price changes
                    />
                  </div>
                </>
              )}
              <div className="buttons_mobile">
                <div className="modelSelector__cleanbutton">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      this.store.onStepSelected({}, this.store.page.pdfStep);
                      setTimeout(() => {
                        SmoothScrolling.scrollTo("step-summary");
                      }, 400);
                    }}
                  >
                    <Translation t="SEND PDF" lang={this.store.page.lang} />
                  </a>
                </div>
              </div>
            </div>
            <div className="delivery">
              <div className="button-wrapper">
                <FooterButtons store={this.store} />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Footer;
